import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: '401.component.html'
})
export class P401Component {

  constructor(
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/shared/401.component.ts